import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ApplicationConstants } from '../../providers/application-constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.css']
})
export class SearchListComponent implements OnInit {

  myControl = new FormControl();
  list = [];
  Acct_Placeholder;

  @Input('placeholder') placeholder: string = '';
  @Input('class_name') class_name: string = '';
  @Input('acct_list') acct_list: any; 
  @Input('row_id') row_id: string; 
  @Input('search_value') search_value: string;

  @Output() search_result = new EventEmitter<string>();

  constructor(public applicationConstants: ApplicationConstants, public translate: TranslateService) { 
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
  }

  ngOnInit() {
    if (this.placeholder == '')
      this.placeholder = this.Acct_Placeholder;

    if (this.class_name == '')
      this.class_name = 'longSearchField';
    // this.list = this.acct_list;
  }

  search(event) {
    // this.applicationConstants.appComp.showBusyCursor();
    this.list = [];
    let value = event.srcElement.value;

    if (value == '')
      this.list = this.acct_list;
    else {
      this.acct_list.forEach(element => {
        // if (element.acct_number.indexOf(value) != -1 || element.sub_acct_name.indexOf(value) != -1 || element.sub_acct_name_en.indexOf(value) != -1)
        if (element.value.indexOf(value) != -1) 
          this.list.push(element);
      });
    }
    // this.applicationConstants.appComp.hideBusyCursor();
  }

  getSearchValue(event) {
    let value = event.srcElement.value;
    let acct_number = '';
    if (value != '') {
      if (this.list.length > 0) {
        for (let index = 0; index < this.list.length && acct_number == ''; index++) {
          if (this.list[index].value == value)
            acct_number = this.list[index].acct_number;
        }
        this.search_result.emit(acct_number);
      }
      else 
        this.search_result.emit(acct_number);
    }
    else 
      this.search_result.emit(acct_number);
  }

  selectValue(event) {
    console.log(event);
    event.srcElement.select();
  }

  selectOption(acct_number) {
    this.search_result.emit(acct_number);
  }

}
